// Sorting of table columns. Text is compared in the Serbian (Latin) alphabet, so č, ć, š, ž
// and đ come right after c, s, z and d instead of at the very end, and "Lokacija 9" comes
// before "Lokacija 10".
const collator = new Intl.Collator(["sr-Latn", "sr", "en"], { numeric: true, sensitivity: "base" })

const isMissing = (value) => value === undefined || value === null || value === ""

const ISO_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/

// Milliseconds since 1970 when the value is a stored time (an ISO string or a large number)
const asTime = (value) => {
  if (typeof value === "string" && ISO_TIME.test(value)) {
    const time = Date.parse(value)
    return Number.isNaN(time) ? null : time
  }
  return typeof value === "number" && value >= 1e11 ? value : null
}

export const compareValues = (a, b) => {
  if (isMissing(a) || isMissing(b)) return (isMissing(a) ? 1 : 0) - (isMissing(b) ? 1 : 0)
  const timeA = asTime(a)
  const timeB = asTime(b)
  if (timeA !== null && timeB !== null) return timeA - timeB
  if (typeof a === "number" && typeof b === "number") return a - b
  if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b)
  return collator.compare(String(a), String(b))
}

// `sortingFn` for @tanstack/react-table
export const smartSort = (rowA, rowB, columnId) => compareValues(rowA.getValue(columnId), rowB.getValue(columnId))

// A copy of `options` ([{ value, label }]) sorted by label, for the lists in drop-downs
export const sortByLabel = (options) => [...options].sort((a, b) => compareValues(a.label, b.label))

// The same list with the items that are already chosen (`isChosen(item)`) first, both parts keeping
// their order. For the pick-lists: what is already ticked is on top while the search is empty.
export const pinChosen = (items, isChosen) => [...items.filter(isChosen), ...items.filter(item => !isChosen(item))]

